<template>
  <div class="app-auto-top-up">
    <div class="header"><slot name="txtHeaderMonthly">Monatliche Aufladung</slot></div>
    <b-col cols="12">
      <b-form-group :class="['monthly-group', { 'not-active':  topUp.type !== 'monthly' } ]" label-for="monthly-group">
        <b-form-radio v-for="day in monthlyValue" v-bind:key="day"
                      :name="'monthly_'+ day"
                      :value="{type: 'monthly', trigger: day}"
                      :id="'monthly_'+ day"
        >
          <b-col md="" sm=""  class="monthly">
            <slot name="txtHeaderMonthlyInside">Monatliche Aufladung</slot>
            <div class="text"><dyn-slot :slot-data="{day: day}"><slot name="lblMonthly">Bitte an jedem {{day}}. eines Monats folgenden Betrag auf mein Konto aufbuchen</slot></dyn-slot></div>
          </b-col>
        </b-form-radio>
        <b-col md="" sm=""  class="monthly-amount">
          <label for="monthly-amount" class="text"><slot name="lblMonthlyAmount">Betrag in Euro</slot></label>
          <b-form-select
            id="monthly-amount"
            v-model="inputMonthly"
            :options="monthlyOptions"
            required
          >
          </b-form-select>
        </b-col>
      </b-form-group>
    </b-col>
    <div class="header"><slot name="txtHeaderByLimit">Aufladung nach Guthabenstand</slot></div>
    <b-col cols="12">
      <b-form-group :class="['byLimit-group', { 'not-active':  topUp.type !== 'byLimit' }]" label-for="byLimit-group">
        <b-form-radio name="byLimit" :value="{'type':'byLimit'}" id="byLimit">
          <slot name="txtHeaderByLimitInside"></slot>
          <slot name="txtDescByLimit"></slot>
          <b-col md="" sm=""  class="trigger">
            <div class="text"><slot name="lblByLimitFirst">Bei einer Guthabenuntergrenze von</slot></div>
            <b-form-select
              id="trigger-amount"
              v-model="inputTrigger"
              :options="triggerOptions"
              required
            >
            </b-form-select>
          </b-col>
          <b-col md="" sm=""  class="threshold">
            <div class="text"><slot name="lblByLimitSecond">bitte automatisch aufladen um</slot></div>
            <b-form-select
              id="threshold-amount"
              v-model="inputThreshold"
              :options="thresholdOptions"
              required
            >
            </b-form-select>
          </b-col>
        </b-form-radio>
      </b-form-group>
    </b-col>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'
import preFilledInput from '@/mixins/preFilledInput'
import price from '@/mixins/price'

export default {
  name: 'EnterAutoTopUp',
  data () {
    return {
      topUpAmounts_: {
        autoAmounts: {
          threshold: {
            amount: [],
            trigger: []
          },
          monthly: {
            amount: []
          }
        }
      }
    }
  },
  methods: {
    buildOptions (optionList) {
      const me = this
      return optionList.map(function (option) {
        return {
          value: option,
          text: me.price(option)
        }
      })
    }
  },
  watch: {
    selectedAutoTopUp: {
      immediate: true,
      handler: function (value) {
        this.$emit('update:trigger', value.trigger)
        this.$emit('update:amount', value.amount)
      }
    }
  },
  computed: {
    topUpAmounts: {
      get () {
        if (this.insideActivation) {
          return this.topUpAmountsStore
        } else {
          return this.topUpAmounts_
        }
      },
      set (value) {
        this.topUpAmounts_ = value
      }
    },
    ...mapGetters('activation/info', {
      topUpAmountsStore: 'topUpAmounts'
    }),
    ...mapGetters([
      'brand'
    ]),
    selectedAutoTopUp () {
      if (this.topUp) {
        if (this.topUp.type === 'monthly') {
          return Object.assign({}, this.topUp, { amount: this.inputMonthly })
        }
        if (this.topUp.type === 'byLimit') {
          return Object.assign({}, this.topUp, { amount: this.inputThreshold }, { trigger: this.inputTrigger })
        }
        return this.topUp
      }
      return {}
    },
    defaultTrigger: function () {
      if (this.topUp.type === 'byLimit' && this.topUp.trigger !== null) {
        const comp = this
        const otherTrigger = this.monthlyValue.find(function (option) {
          return option === comp.topUp.trigger
        })
        if (typeof otherTrigger === 'undefined') {
          return this.topUp.trigger
        }
      }
      return this.topUpAmounts.autoAmounts.threshold.defaultTrigger
    },
    defaultThreshold: function () {
      if (this.topUp.type === 'byLimit' && this.topUp.amount !== null) {
        return this.topUp.amount
      }
      return this.topUpAmounts.autoAmounts.threshold.default
    },
    defaultMonthly: function () {
      if (this.topUp.type === 'monthly' && this.topUp.amount !== null) {
        return this.topUp.amount
      }
      return this.topUpAmounts.autoAmounts.monthly.default
    },
    triggerOptions: function () {
      return this.buildOptions(this.topUpAmounts.autoAmounts.threshold.trigger)
    },
    thresholdOptions: function () {
      return this.buildOptions(this.topUpAmounts.autoAmounts.threshold.amount)
    },
    monthlyOptions: function () {
      return this.buildOptions(this.topUpAmounts.autoAmounts.monthly.amount)
    }
  },
  mixins: [
    preFilledInput('inputTrigger', 'defaultTrigger'),
    preFilledInput('inputMonthly', 'defaultMonthly'),
    preFilledInput('inputThreshold', 'defaultThreshold'),
    price
  ],
  props:
    {
      topUp: {
        type: Object
      },
      monthlyValue: {
        type: Array
      },
      insideActivation: {
        type: Boolean,
        default: false
      }
    },
  apollo: {
    topUpAmounts: function () {
      return wrapQuery(
        gql`
        query($brand: String!) {
          topUpAmounts(brand: $brand) {
            autoAmounts {
              monthly {
                amount,
                default
              }
              threshold {
                amount,
                default,
                defaultTrigger,
                trigger
              }
            }
          }
        }
      `,
        this,
        'topUpAmounts',
        {
          brand: this.brand
        },
        null,
        {
          fetchPolicy: 'cache-first',
          skip: this.insideActivation
        }
      )
    }
  }
}
</script>
